$(document).ready(function(e){

  var $variants = $('.variant-custom-fields');
  var $form = $('form[action="/cart/add"]');

  // Set the active variant on page load.
  setActiveVariantCustomFields($form, $variants);
  
  // Toggle display when dropdown changed in the "Add to Cart" feature.
  $form.change(function() {
      setActiveVariantCustomFields($form, $variants);
    setTimeout(function(){
     var getTitle = $(".template-product .product-main h1.product-title .variant-custom-fields:visible .variant__cf").text().trim();
        $("nav.breadcrumbs-container a:last-child").html(getTitle);
        }, 100);
  });
  
  /**
   * Sets the active variant based on the "id" select dropdown in the add to cart form.
   */
  function setActiveVariantCustomFields($form, $variants){
    //$variants.hide();
    setTimeout(function(){
      var active_variant_id = $form.find('select[name="id"]').val();
      //$variants.filter('[data-variant-id="'+ active_variant_id +'"]').show();  
      $('.variant-custom-fields').each(function(){
      var act_id = $(this).attr("data-variant-id")
      if(active_variant_id == act_id){
        $(this).show();
      }  
      else{
         $(this).hide();
      }  
     });
      
    }, 100);
  }
});